import { useMemo } from 'react';
import { useLocation } from 'react-router';

/**
 * @module hooks/useQueryParams
 * @category Hooks
 */

/**
 * Helper hook for resolving broser search query parameters.
 *
 * @returns {URLSearchParams}
 */
const useQueryParams = () => {
  const location = useLocation();

  return useMemo(() => {
    const { search, hash } = location;

    const completeSearch = [search, hash.replace('#', '')].join('&');
    return new URLSearchParams(completeSearch);
  }, [location]);
};

export default useQueryParams;
